import m from "../../geodata/es2015/sriLankaHigh";
window.am4geodata_sriLankaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sriLankaHigh.js
// module id = null
// module chunks = 